// extracted by mini-css-extract-plugin
module.exports = {"container":"PhoneNumber_container__2ptN3","formContainer":"PhoneNumber_formContainer__EcS2v"};